/**
 * callec-reviews — 自作レビューのフロント側。
 *
 * 3つの役割を1ファイルで持つ(data-rv-role で切替):
 *   pdp     商品ページのサマリ・一覧・絞り込み・参考になった・Q&A
 *   form    投稿ページ(/pages/review)。購入品の選択、星、指標、写真の縮小アップロード
 *   recent  新着グリッド(TOP / LP / 一覧ページ)
 *
 * API は App Proxy(/apps/reviews/*)。ログイン状態は Liquid が data 属性で渡す。
 * サイズ感・着心地は Klaviyo と同じ 5段階(両端ラベル)の指標で描く。
 */
(function () {
  'use strict';

  var STAR = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.5l2.9 6.3 6.9.8-5.1 4.7 1.4 6.8L12 17.7l-6.1 3.4 1.4-6.8L2.2 9.6l6.9-.8z"/></svg>';
  var SCALES = {
    fit: { label: 'サイズ感', min: '小さい', center: 'ちょうどよい', max: '大きい' },
    comfort: { label: '着心地', min: '悪い', center: '普通', max: '良い' }
  };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function fmtDate(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    return d.getFullYear() + '/' + String(d.getMonth() + 1).padStart(2, '0') + '/' + String(d.getDate()).padStart(2, '0');
  }
  function stars(n, size) {
    var html = '<span class="rv__stars' + (size === 'lg' ? ' rv__stars--lg' : '') + '" role="img" aria-label="' + n + ' / 5">';
    for (var i = 1; i <= 5; i++) {
      var cls = n >= i ? '' : (n >= i - 0.5 ? ' class="is-half"' : ' class="is-off"');
      html += STAR.replace('<svg', '<svg' + cls);
    }
    return html + '</span>';
  }
  /** 5段階の指標。value は 1〜5(小数可)。null なら描かない */
  function indicator(kind, value, opts) {
    if (value == null) return '';
    var sc = SCALES[kind];
    var o = opts || {};
    var pct = ((value - 1) / 4) * 100;
    return '<div class="rv__ind" role="img" aria-label="' + sc.label + ' ' + value + ' / 5">'
      + '<span class="rv__ind-lbl">' + sc.label + (o.note ? '<small>' + esc(o.note) + '</small>' : '') + '</span>'
      + '<span class="rv__ind-track"><i class="rv__ind-tick"></i><b class="rv__ind-dot" style="left:' + pct + '%"></b></span>'
      + '<span class="rv__ind-ends"><span>' + sc.min + '</span><span>' + sc.center + '</span><span>' + sc.max + '</span></span>'
      + '</div>';
  }
  function api(base, path, options) {
    var opts = options || {};
    var headers = opts.body && !(opts.body instanceof FormData) ? { 'Content-Type': 'application/json' } : {};
    return fetch(base + path, Object.assign({ credentials: 'same-origin', headers: headers }, opts)).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (body) {
        if (!res.ok || body.ok === false) {
          var err = new Error(body.error || '通信に失敗しました');
          err.code = body.code; err.status = res.status;
          throw err;
        }
        return body;
      });
    });
  }
  function voterKey() {
    try {
      var k = localStorage.getItem('cec_rv_voter');
      if (!k) {
        var a = new Uint8Array(16); crypto.getRandomValues(a);
        k = Array.prototype.map.call(a, function (b) { return ('0' + b.toString(16)).slice(-2); }).join('');
        localStorage.setItem('cec_rv_voter', k);
      }
      return k;
    } catch (e) { return 'anon' + Date.now().toString(16) + 'xxxxxxxx'; }
  }
  function votedSet() {
    try { return JSON.parse(localStorage.getItem('cec_rv_voted') || '[]'); } catch (e) { return []; }
  }
  function markVoted(id) {
    try { var s = votedSet(); if (s.indexOf(id) < 0) { s.push(id); localStorage.setItem('cec_rv_voted', JSON.stringify(s.slice(-200))); } } catch (e) {}
  }
  function profileLine(p) {
    if (!p) return '';
    var parts = [];
    if (p.height_cm) parts.push(p.height_cm + 'cm');
    if (p.weight_kg) parts.push(p.weight_kg + 'kg');
    return parts.join(' / ');
  }
  /**
   * 「172cm / 64kg で M / BLACK を着用」。体型と着たサイズを1行でつなげて読めるようにする。
   * 以前あった「普段のサイズ」は着用サイズと役割が重なって分かりにくいため廃止(2026-09-14)
   */
  function wearLine(r, showProfile) {
    var body = showProfile !== false && r.profile ? profileLine(r.profile) : '';
    var size = r.variant_title && r.variant_title !== 'Default Title' ? r.variant_title : '';
    if (body && size) return body + ' で ' + size + ' を着用';
    if (size) return size + ' を着用';
    return body;
  }

  /* ---------- ライトボックス ---------- */
  function openLightbox(url) {
    var lb = document.createElement('div');
    lb.className = 'rv__lb';
    lb.innerHTML = '<button type="button" class="rv__lb-close" aria-label="閉じる">×</button><img src="' + esc(url) + '" alt="">';
    lb.addEventListener('click', function () { lb.remove(); });
    document.body.appendChild(lb);
  }

  /* ---------- レビュー1件の描画(pdp / recent 共通) ---------- */
  function reviewCard(r, opts) {
    var o = opts || {};
    var voted = votedSet().indexOf(r.id) >= 0;
    var helpfulLabel = o.helpfulLabel || '参考になった';
    var photos = (r.media || []).map(function (m) {
      return '<button type="button" data-rv-photo="' + esc(m.url) + '"><img src="' + esc(m.url) + '" alt="" loading="lazy"></button>';
    }).join('');
    var meta = '<span class="rv__author">' + esc(r.author) + '</span>'
      + (r.verified ? '<span class="rv__badge rv__badge--ok">購入者</span>' : '')
      + '<span>' + fmtDate(r.created_at) + '</span>'
      + (wearLine(r, o.showProfile) ? '<span class="rv__wear">' + esc(wearLine(r, o.showProfile)) + '</span>' : '');
    var inds = '';
    if (o.showFit !== false && r.fit_score != null) inds += indicator('fit', r.fit_score);
    if (o.showComfort !== false && r.comfort != null) inds += indicator('comfort', r.comfort);
    var body = esc(r.body);
    var long = r.body.length > 160 || (r.body.match(/\n/g) || []).length > 4;
    return '<article class="rv__item" data-rv-id="' + r.id + '">'
      + '<div class="rv__item-head">' + stars(r.rating) + (r.title ? '<span class="rv__item-title">' + esc(r.title) + '</span>' : '') + '</div>'
      + '<p class="rv__item-body' + (long ? ' is-clamped' : '') + '">' + body + '</p>'
      + (long ? '<button type="button" class="rv__more" data-rv-more>続きを読む</button>' : '')
      + (inds ? '<div class="rv__inds">' + inds + '</div>' : '')
      + '<div class="rv__meta">' + meta + '</div>'
      + (photos ? '<div class="rv__photos">' + photos + '</div>' : '')
      + (r.reply ? '<div class="rv__reply"><span class="rv__reply-lbl">CALL&amp;RESPONSE からの返信 ' + fmtDate(r.replied_at) + '</span>' + esc(r.reply) + '</div>' : '')
      + (o.helpful !== false ? '<div class="rv__foot"><button type="button" class="rv__helpful" data-rv-helpful="' + r.id + '" aria-pressed="' + (voted ? 'true' : 'false') + '">' + esc(helpfulLabel) + (r.helpful ? ' ' + r.helpful : '') + '</button></div>' : '')
      + '</article>';
  }

  function bindCardEvents(root, base, helpfulLabel) {
    root.addEventListener('click', function (ev) {
      var t = ev.target.closest('[data-rv-photo]');
      if (t) { openLightbox(t.getAttribute('data-rv-photo')); return; }
      var m = ev.target.closest('[data-rv-more]');
      if (m) { var p = m.previousElementSibling; p.classList.remove('is-clamped'); m.remove(); return; }
      var h = ev.target.closest('[data-rv-helpful]');
      if (h) {
        if (h.getAttribute('aria-pressed') === 'true') return;
        var id = Number(h.getAttribute('data-rv-helpful'));
        h.setAttribute('aria-pressed', 'true');
        api(base, '/vote', { method: 'POST', body: JSON.stringify({ review_id: id, voter_key: voterKey() }) }).then(function (r) {
          markVoted(id);
          h.textContent = (helpfulLabel || '参考になった') + ' ' + r.helpful;
        }).catch(function () { h.setAttribute('aria-pressed', 'false'); });
      }
    });
  }

  /* ---------- PDP ---------- */
  function initPdp(root) {
    var base = root.getAttribute('data-proxy-base') || '/apps/reviews';
    var productId = root.getAttribute('data-product-id');
    var per = Number(root.getAttribute('data-per') || '5');
    var helpfulLabel = root.getAttribute('data-helpful-label') || '参考になった';
    var state = { sort: root.getAttribute('data-sort') || 'recent', fit: '', photos: false, rating: 0, height: '', page: 1, items: [], total: 0, qaPage: 1, qaLoaded: false };
    var summaryEl = root.querySelector('[data-rv-summary]');
    var listEl = root.querySelector('[data-rv-list]');
    var toolsEl = root.querySelector('[data-rv-tools]');
    var moreEl = root.querySelector('[data-rv-loadmore]');
    var countEls = root.querySelectorAll('[data-rv-count], [data-rv-count-tab]');
    var showFit = root.getAttribute('data-show-fit') !== 'false';
    var showComfort = root.getAttribute('data-show-comfort') !== 'false';
    var showProfile = root.getAttribute('data-show-profile') !== 'false';
    var cardOpts = { showProfile: showProfile, showFit: showFit, showComfort: showComfort, helpfulLabel: helpfulLabel };

    function query() {
      var q = '?product_id=' + productId + '&sort=' + state.sort + '&page=' + state.page + '&per=' + per;
      if (state.fit) q += '&fit=' + state.fit;
      if (state.photos) q += '&photos=1';
      if (state.rating) q += '&rating=' + state.rating;
      if (state.height) {
        var hr = state.height.split('-');
        if (hr[0]) q += '&height_min=' + hr[0];
        if (hr[1]) q += '&height_max=' + hr[1];
      }
      return q;
    }

    function renderSummary(s) {
      countEls.forEach(function (el) { el.textContent = s.count || ''; });
      var qaCount = root.querySelector('[data-rv-qa-count]');
      if (qaCount) qaCount.textContent = s.questions || '';
      if (!s.count) {
        summaryEl.innerHTML = '<div class="rv__empty">まだレビューはありません。最初のレビューをお待ちしています。</div>';
        toolsEl.hidden = true;
        return;
      }
      var dist = '';
      for (var i = 5; i >= 1; i--) {
        var n = s.dist[String(i)] || 0;
        dist += '<button type="button" class="rv__dist-row" data-rv-rating="' + i + '" aria-pressed="' + (state.rating === i ? 'true' : 'false') + '">'
          + '<span>' + i + '★</span><span class="rv__bar"><i style="width:' + Math.round((n / s.count) * 100) + '%"></i></span><span>' + n + '</span></button>';
      }
      var scales = '';
      if (showFit && s.fit_scale && s.fit_scale.answered > 0) scales += indicator('fit', s.fit_scale.avg, { note: s.fit_scale.answered + '人が回答' });
      if (showComfort && s.comfort && s.comfort.answered > 0) scales += indicator('comfort', s.comfort.avg, { note: s.comfort.answered + '人が回答' });
      summaryEl.innerHTML = '<div class="rv__avg"><span class="rv__avg-n">' + s.avg.toFixed(1) + '</span>' + stars(s.avg, 'lg') + '<span class="rv__avg-c">' + s.count + '件のレビュー</span></div>'
        + '<div class="rv__dist">' + dist + '</div>' + (scales ? '<div class="rv__scales">' + scales + '</div>' : '');
      toolsEl.hidden = false;
      var photoChip = toolsEl.querySelector('[data-rv-chip="photos"]');
      if (photoChip) photoChip.hidden = s.with_photos === 0;
      toolsEl.querySelectorAll('[data-rv-chip^="fit:"]').forEach(function (c) { c.hidden = !(s.fit && s.fit.answered > 0); });
    }

    function renderList(append) {
      if (!append) listEl.innerHTML = '';
      if (!state.items.length && !append) {
        listEl.innerHTML = '<div class="rv__empty">条件に合うレビューはありません</div>';
      } else {
        var html = state.items.map(function (r) { return reviewCard(r, cardOpts); }).join('');
        if (append) listEl.insertAdjacentHTML('beforeend', html); else listEl.innerHTML = html;
      }
      moreEl.hidden = state.page * per >= state.total;
    }

    function load(append) {
      if (!append) { state.page = 1; listEl.innerHTML = '<div class="rv__skel"></div>'; }
      return api(base, '/list' + query()).then(function (r) {
        state.items = r.items; state.total = r.total;
        renderList(append);
      }).catch(function () {
        listEl.innerHTML = '<div class="rv__empty">レビューを読み込めませんでした。時間をおいて再度お試しください。</div>';
        moreEl.hidden = true;
      });
    }

    toolsEl.addEventListener('click', function (ev) {
      var c = ev.target.closest('[data-rv-chip]');
      if (!c) return;
      var kind = c.getAttribute('data-rv-chip');
      var on = c.getAttribute('aria-pressed') !== 'true';
      if (kind === 'photos') { state.photos = on; c.setAttribute('aria-pressed', on ? 'true' : 'false'); }
      else if (kind.indexOf('fit:') === 0) {
        var v = kind.slice(4);
        state.fit = on ? v : '';
        toolsEl.querySelectorAll('[data-rv-chip^="fit:"]').forEach(function (x) { x.setAttribute('aria-pressed', x === c && on ? 'true' : 'false'); });
      }
      load(false);
    });
    toolsEl.addEventListener('change', function (ev) {
      var s = ev.target.closest('select[data-rv-sort]');
      if (s) { state.sort = s.value; load(false); }
      var h = ev.target.closest('select[data-rv-height]');
      if (h) { state.height = h.value; load(false); }
    });
    summaryEl.addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-rv-rating]');
      if (!b) return;
      var n = Number(b.getAttribute('data-rv-rating'));
      state.rating = state.rating === n ? 0 : n;
      summaryEl.querySelectorAll('[data-rv-rating]').forEach(function (x) { x.setAttribute('aria-pressed', Number(x.getAttribute('data-rv-rating')) === state.rating ? 'true' : 'false'); });
      load(false);
    });
    moreEl.addEventListener('click', function () { state.page += 1; load(true); });
    bindCardEvents(listEl, base, helpfulLabel);

    /* --- Q&A --- */
    var qaList = root.querySelector('[data-rv-qa-list]');
    var qaMore = root.querySelector('[data-rv-qa-loadmore]');
    var askForm = root.querySelector('[data-rv-ask-form]');
    function qaCard(q) {
      return '<article class="rv__qa">'
        + '<div class="rv__qa-q"><span class="rv__qa-mark">Q</span><div><p class="rv__qa-text">' + esc(q.question) + '</p><div class="rv__meta"><span class="rv__author">' + esc(q.author) + '</span><span>' + fmtDate(q.created_at) + '</span></div></div></div>'
        + (q.answer ? '<div class="rv__qa-a"><span class="rv__qa-mark rv__qa-mark--a">A</span><div><p class="rv__qa-text">' + esc(q.answer) + '</p><div class="rv__meta"><span class="rv__author">CALL&amp;RESPONSE</span><span>' + fmtDate(q.answered_at) + '</span></div></div></div>' : '')
        + '</article>';
    }
    function loadQa(append) {
      if (!qaList) return;
      if (!append) { state.qaPage = 1; qaList.innerHTML = '<div class="rv__skel"></div>'; }
      api(base, '/questions?product_id=' + productId + '&page=' + state.qaPage + '&per=10').then(function (r) {
        var html = r.items.map(qaCard).join('');
        if (append) qaList.insertAdjacentHTML('beforeend', html);
        else qaList.innerHTML = html || '<div class="rv__empty">まだ質問はありません。気になることがあれば、お気軽にどうぞ。</div>';
        if (qaMore) qaMore.hidden = state.qaPage * 10 >= r.total;
        state.qaLoaded = true;
      }).catch(function () { qaList.innerHTML = '<div class="rv__empty">Q&amp;A を読み込めませんでした</div>'; });
    }
    if (qaMore) qaMore.addEventListener('click', function () { state.qaPage += 1; loadQa(true); });
    root.querySelectorAll('[data-rv-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var name = tab.getAttribute('data-rv-tab');
        root.querySelectorAll('[data-rv-tab]').forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
        root.querySelectorAll('[data-rv-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-rv-panel') !== name; });
        if (name === 'qa' && !state.qaLoaded) loadQa(false);
      });
    });
    if (askForm) {
      askForm.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var ta = askForm.querySelector('textarea');
        var msg = askForm.querySelector('[data-rv-ask-msg]');
        var btn = askForm.querySelector('button[type=submit]');
        btn.disabled = true; msg.textContent = '';
        api(base, '/question', { method: 'POST', body: JSON.stringify({ product_id: productId, question: ta.value }) }).then(function () {
          ta.value = '';
          msg.textContent = '質問をお預かりしました。回答ができ次第、こちらに掲載します。';
        }).catch(function (e) { msg.textContent = e.message; }).then(function () { btn.disabled = false; });
      });
    }

    /* --- 投稿モーダル --- */
    var writeBtn = root.querySelector('[data-rv-write]');
    function openWriteModal() {
      openFormModal({
        base: base,
        mypageUrl: root.getAttribute('data-mypage-url') || '/pages/mypage',
        maxPhotos: Number(root.getAttribute('data-max-photos') || '3'),
        preselect: productId,
        onClose: function (submitted) {
          if (submitted) { api(base, '/summary?product_id=' + productId).then(renderSummary).catch(function () {}); load(false); }
        }
      });
    }
    if (writeBtn) writeBtn.addEventListener('click', openWriteModal);
    if (writeBtn && location.hash === '#callec-reviews-write') {
      // ログイン後に戻ってきた時。位置を合わせてから開く
      setTimeout(function () { root.scrollIntoView({ block: 'start' }); openWriteModal(); }, 300);
    }

    // サマリの取得に失敗しても Liquid が出した平均・件数はそのまま残す(アプリ未接続時など)
    api(base, '/summary?product_id=' + productId).then(renderSummary).catch(function () {
      var skel = summaryEl.querySelector('.rv__skel'); if (skel) skel.remove();
      toolsEl.hidden = true;
    });
    load(false);
    // URL に #callec-reviews-qa があれば Q&A を開く
    if (location.hash === '#callec-reviews-qa') { var qtab = root.querySelector('[data-rv-tab="qa"]'); if (qtab) qtab.click(); }
  }

  /* ---------- 新着グリッド ---------- */
  function initRecent(root) {
    var base = root.getAttribute('data-proxy-base') || '/apps/reviews';
    var per = Number(root.getAttribute('data-per') || '8');
    var photos = root.getAttribute('data-photos') === 'true';
    var gridEl = root.querySelector('[data-rv-grid]');
    var moreEl = root.querySelector('[data-rv-loadmore]');
    var page = 1;
    function card(r) {
      var img = r.media && r.media.length ? r.media[0].url : (r.product && r.product.image);
      return '<div class="rvg__card">'
        + (img ? '<a class="rvg__img" href="' + esc(r.product.url) + '"><img src="' + esc(img) + '" alt="" loading="lazy"></a>' : '')
        + '<div class="rvg__body">' + stars(r.rating)
        + (r.title ? '<strong>' + esc(r.title) + '</strong>' : '')
        + '<p class="rvg__text">' + esc(r.body) + '</p>'
        + '<span class="rv__meta"><span class="rv__author">' + esc(r.author) + '</span>' + (wearLine(r) ? '<span>' + esc(wearLine(r)) + '</span>' : '') + '</span>'
        + '<a class="rvg__prod" href="' + esc(r.product.url) + '">' + esc(r.product.title) + '</a>'
        + '</div></div>';
    }
    function load(append) {
      api(base, '/recent?page=' + page + '&per=' + per + (photos ? '&photos=1' : '')).then(function (r) {
        var html = r.items.map(card).join('');
        if (append) gridEl.insertAdjacentHTML('beforeend', html); else gridEl.innerHTML = html || '<div class="rv__empty">まだレビューはありません</div>';
        if (moreEl) moreEl.hidden = page * per >= r.total;
      }).catch(function (e) { gridEl.innerHTML = '<div class="rv__err">' + esc(e.message) + '</div>'; });
    }
    if (moreEl) moreEl.addEventListener('click', function () { page += 1; load(true); });
    load(false);
  }

  /* ---------- 投稿フォーム ---------- */
  function resizeImage(file, maxSide, quality) {
    return new Promise(function (resolve) {
      var img = new Image();
      var url = URL.createObjectURL(file);
      img.onload = function () {
        var w = img.naturalWidth, h = img.naturalHeight;
        var scale = Math.min(1, maxSide / Math.max(w, h));
        var cw = Math.round(w * scale), ch = Math.round(h * scale);
        var c = document.createElement('canvas'); c.width = cw; c.height = ch;
        c.getContext('2d').drawImage(img, 0, 0, cw, ch);
        URL.revokeObjectURL(url);
        c.toBlob(function (blob) { resolve(blob ? new File([blob], 'photo.jpg', { type: 'image/jpeg' }) : file); }, 'image/jpeg', quality);
      };
      img.onerror = function () { URL.revokeObjectURL(url); resolve(file); };
      img.src = url;
    });
  }

  /**
   * 書く・直すのモーダル。商品ページとレビューページの両方から使う。
   * opts.existing があれば編集、無ければ opts.preselect の商品の新規投稿。
   */
  function openFormModal(opts) {
    if (document.querySelector('.rv__modal')) return;
    var title = opts.existing ? 'レビューを編集' : 'レビューを書く';
    var modal = document.createElement('div');
    modal.className = 'rv rv__modal';
    modal.innerHTML = '<div class="rv__modal-panel" role="dialog" aria-modal="true" aria-label="' + title + '">'
      + '<div class="rv__modal-head"><span class="rv__modal-title">' + title + '</span><button type="button" class="rv__modal-close" data-rv-modal-close aria-label="閉じる">×</button></div>'
      + '<div class="rv__modal-body"><div data-rvf-body><div class="rv__skel"></div></div></div></div>';
    document.body.appendChild(modal);
    document.documentElement.classList.add('rv-modal-open');
    var submitted = false;
    function close() {
      modal.remove();
      document.documentElement.classList.remove('rv-modal-open');
      document.removeEventListener('keydown', onKey);
      if (opts.onClose) opts.onClose(submitted);
    }
    function onKey(ev) { if (ev.key === 'Escape') close(); }
    document.addEventListener('keydown', onKey);
    modal.addEventListener('click', function (ev) {
      if (ev.target === modal || ev.target.closest('[data-rv-modal-close]')) close();
    });
    mountForm(modal.querySelector('[data-rvf-body]'), {
      base: opts.base,
      mypageUrl: opts.mypageUrl,
      maxPhotos: opts.maxPhotos,
      preselect: opts.preselect,
      existing: opts.existing,
      single: true,
      onDone: function () { submitted = true; modal.querySelector('.rv__modal-body').scrollTop = 0; }
    });
  }

  /** 確認ダイアログ。window.confirm は見た目がそろわないので使わない */
  function confirmDialog(titleText, bodyText, okLabel) {
    return new Promise(function (resolve) {
      var el = document.createElement('div');
      el.className = 'rv rv__modal rv__modal--dialog';
      el.innerHTML = '<div class="rv__dialog" role="alertdialog" aria-modal="true"><p class="rv__dialog-title">' + esc(titleText) + '</p>'
        + (bodyText ? '<p class="rv__dialog-text">' + esc(bodyText) + '</p>' : '')
        + '<div class="rv__dialog-actions"><button type="button" class="rv__btn rv__btn--ghost" data-r="0">キャンセル</button><button type="button" class="rv__btn rv__btn--danger" data-r="1">' + esc(okLabel) + '</button></div></div>';
      function done(v) { el.remove(); document.removeEventListener('keydown', onKey); resolve(v); }
      function onKey(ev) { if (ev.key === 'Escape') done(false); }
      el.addEventListener('click', function (ev) {
        if (ev.target === el) return done(false);
        var b = ev.target.closest('[data-r]'); if (b) done(b.getAttribute('data-r') === '1');
      });
      document.addEventListener('keydown', onKey);
      document.body.appendChild(el);
      el.querySelector('[data-r="0"]').focus();
    });
  }

  /** 5段階の選択コントロール(サイズ感・着心地) */
  function scaleControl(kind, value) {
    var sc = SCALES[kind];
    var btns = '';
    for (var i = 1; i <= 5; i++) {
      btns += '<button type="button" class="rvf__pt" data-rvf-scale="' + kind + '" data-v="' + i + '" aria-pressed="' + (value === i ? 'true' : 'false') + '" aria-label="' + sc.label + ' ' + i + '"><i></i></button>';
    }
    var picked = value ? (value <= 2 ? (value === 1 ? sc.min : 'やや' + sc.min) : value >= 4 ? (value === 5 ? sc.max : 'やや' + sc.max) : sc.center) : '';
    return '<div class="rvf__scale"><div class="rvf__scale-row"><span class="rvf__scale-line"></span>' + btns + '</div>'
      + '<div class="rvf__scale-ends"><span>' + sc.min + '</span><span class="rvf__scale-picked" data-rvf-scale-picked="' + kind + '">' + picked + '</span><span>' + sc.max + '</span></div></div>';
  }

  /**
   * レビューページ(/pages/review)。「まだレビューしていない商品」と「投稿したレビュー」を1ページにまとめる。
   * 書く・直すはどちらもモーダル。?product=<商品ID> で来たら(依頼メールなど)その商品のモーダルを開く。
   */
  function initForm(root) {
    if (root.getAttribute('data-logged-in') !== 'true') return; // Liquid 側がログイン導線を出している
    var base = root.getAttribute('data-proxy-base') || '/apps/reviews';
    var mypageUrl = root.getAttribute('data-mypage-url') || '/pages/mypage';
    var maxPhotos = Number(root.getAttribute('data-max-photos') || '3');
    var body = root.querySelector('[data-rvf-body]');
    var preselect = new URLSearchParams(location.search).get('product') || '';
    var mine = [];
    var openedDeepLink = false;
    var STATUS = {
      pending: { label: '確認中', cls: '', note: '確認が済むと商品ページに掲載されます。' },
      approved: { label: '掲載中', cls: 'rv__badge--ok', note: '' },
      rejected: { label: '掲載を見送りました', cls: 'rv__badge--muted', note: '掲載の基準に合わなかったため、商品ページには表示していません。内容を直すと、あらためて確認します。' }
    };

    function todoCard(it) {
      return '<div class="rvp__todo">'
        + (it.image ? '<img src="' + esc(it.image) + '" alt="" loading="lazy">' : '<span class="rvp__noimg"></span>')
        + '<div class="rvp__todo-body"><span class="rvp__ptitle">' + esc(it.title) + '</span>'
        + '<span class="rvp__sub">' + esc(it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title + ' ・ ' : '') + (it.ordered_at ? fmtDate(it.ordered_at) + ' 購入' : '') + '</span></div>'
        + '<button type="button" class="rv__btn rvp__write" data-rvp-write="' + esc(it.product_id) + '">レビューを書く</button></div>';
    }

    function mineCard(r) {
      var st = STATUS[r.status] || STATUS.pending;
      var p = r.product || {};
      var edited = r.updated_at && r.created_at && r.updated_at.slice(0, 16) !== r.created_at.slice(0, 16);
      var inds = (r.fit_score != null ? indicator('fit', r.fit_score) : '') + (r.comfort != null ? indicator('comfort', r.comfort) : '');
      var wear = wearLine({ profile: r.show_profile ? { height_cm: r.height_cm, weight_kg: r.weight_kg } : null, variant_title: r.variant_title });
      var long = r.body.length > 160;
      return '<article class="rvp__card" data-rvp-id="' + r.id + '">'
        + '<div class="rvp__card-head">'
        +   (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy">' : '<span class="rvp__noimg"></span>')
        +   '<div class="rvp__card-meta">'
        +     (p.url && p.active ? '<a class="rvp__ptitle" href="' + esc(p.url) + '#callec-reviews">' + esc(p.title) + '</a>' : '<span class="rvp__ptitle">' + esc(p.title || '販売を終了した商品') + '</span>')
        +     '<span class="rvp__sub">' + fmtDate(r.created_at) + ' 投稿' + (edited ? ' ・ ' + fmtDate(r.updated_at) + ' 編集' : '') + '</span>'
        +   '</div>'
        +   '<span class="rv__badge ' + st.cls + '">' + st.label + '</span>'
        + '</div>'
        + '<div class="rv__item-head">' + stars(r.rating) + (r.title ? '<span class="rv__item-title">' + esc(r.title) + '</span>' : '') + '</div>'
        + '<p class="rv__item-body' + (long ? ' is-clamped' : '') + '">' + esc(r.body) + '</p>'
        + (long ? '<button type="button" class="rv__more" data-rv-more>続きを読む</button>' : '')
        + (inds ? '<div class="rv__inds">' + inds + '</div>' : '')
        + '<div class="rv__meta"><span class="rv__author">' + esc(r.author) + '</span>' + (wear ? '<span class="rv__wear">' + esc(wear) + '</span>' : '') + (r.status === 'approved' && r.helpful ? '<span>' + r.helpful + '人が参考になったと回答</span>' : '') + '</div>'
        + (r.reply ? '<div class="rv__reply"><span class="rv__reply-lbl">CALL&amp;RESPONSE からの返信 ' + fmtDate(r.replied_at) + '</span>' + esc(r.reply) + '</div>' : '')
        + (st.note ? '<p class="rvp__note">' + st.note + '</p>' : '')
        + '<div class="rvp__actions">'
        +   (p.url && r.status === 'approved' && p.active ? '<a class="rv__btn rv__btn--ghost rvp__small" href="' + esc(p.url) + '#callec-reviews">商品ページで見る</a>' : '')
        +   '<span class="rvp__spacer"></span>'
        +   '<button type="button" class="rvp__link" data-rvp-edit="' + r.id + '">編集する</button>'
        +   '<button type="button" class="rvp__link rvp__link--danger" data-rvp-delete="' + r.id + '">削除</button>'
        + '</div></article>';
    }

    function render(eligible, mineRes) {
      mine = mineRes.items || [];
      var todo = eligible.items || [];
      var questions = mineRes.questions || [];
      var html = '<section class="rvp__section"><h2 class="rvp__h">まだレビューしていない商品<span class="rvp__count">' + todo.length + '</span></h2>'
        + (todo.length ? '<div class="rvp__todos">' + todo.map(todoCard).join('') + '</div>'
          : '<div class="rv__empty">レビューできる商品はありません。直近1年にご購入いただいた商品が対象です。</div>')
        + '</section>'
        + '<section class="rvp__section"><h2 class="rvp__h">投稿したレビュー<span class="rvp__count">' + mine.length + '</span></h2>'
        + (mine.length ? '<div class="rvp__cards">' + mine.map(mineCard).join('') + '</div>'
          : '<div class="rv__empty">まだ投稿したレビューはありません。</div>')
        + '</section>';
      if (questions.length) {
        var ql = { pending: '回答待ち', answered: '回答済み', hidden: '非掲載' };
        html += '<section class="rvp__section"><h2 class="rvp__h">投稿した質問<span class="rvp__count">' + questions.length + '</span></h2><div class="rv__list rv--lines">' + questions.map(function (q) {
          return '<div class="rv__item"><div class="rv__item-head"><span class="rv__badge">' + (ql[q.status] || q.status) + '</span><span class="rv__meta">' + fmtDate(q.created_at) + '</span></div><p class="rv__item-body">' + esc(q.question) + '</p>'
            + (q.answer ? '<div class="rv__reply"><span class="rv__reply-lbl">回答 ' + fmtDate(q.answered_at) + '</span>' + esc(q.answer) + '</div>' : '') + '</div>';
        }).join('') + '</div></section>';
      }
      html += '<p class="rvp__back"><a class="rv__btn rv__btn--ghost" href="' + esc(mypageUrl) + '">マイページへ戻る</a></p>';
      body.innerHTML = html;

      if (preselect && !openedDeepLink) {
        openedDeepLink = true;
        if (todo.some(function (it) { return String(it.product_id) === String(preselect); })) openWrite(preselect);
      }
    }

    function load() {
      return Promise.all([api(base, '/eligible'), api(base, '/mine')]).then(function (res) { render(res[0], res[1]); }).catch(function (e) {
        body.innerHTML = '<div class="rv__err">' + esc(e.message) + '</div>';
      });
    }
    function openWrite(pid) {
      openFormModal({ base: base, mypageUrl: mypageUrl, maxPhotos: maxPhotos, preselect: pid, onClose: function (submitted) { if (submitted) load(); } });
    }
    function notice(text) {
      var el = document.createElement('div');
      el.className = 'rvp__toast'; el.textContent = text;
      document.body.appendChild(el);
      setTimeout(function () { el.remove(); }, 3000);
    }

    body.addEventListener('click', function (ev) {
      var w = ev.target.closest('[data-rvp-write]');
      if (w) { openWrite(w.getAttribute('data-rvp-write')); return; }
      var m = ev.target.closest('[data-rv-more]');
      if (m) { m.previousElementSibling.classList.remove('is-clamped'); m.remove(); return; }
      var ed = ev.target.closest('[data-rvp-edit]');
      if (ed) {
        var r = mine.find(function (x) { return String(x.id) === ed.getAttribute('data-rvp-edit'); });
        if (r) openFormModal({ base: base, mypageUrl: mypageUrl, maxPhotos: maxPhotos, existing: r, onClose: function (submitted) { if (submitted) load(); } });
        return;
      }
      var del = ev.target.closest('[data-rvp-delete]');
      if (del) {
        confirmDialog('このレビューを削除しますか?', '削除すると元に戻せません。商品ページからも消えます。', '削除する').then(function (ok) {
          if (!ok) return;
          del.disabled = true;
          api(base, '/review/' + del.getAttribute('data-rvp-delete') + '/delete', { method: 'POST', body: '{}' }).then(function () {
            notice('レビューを削除しました');
            load();
          }).catch(function (e) { del.disabled = false; notice(e.message); });
        });
      }
    });

    body.innerHTML = '<div class="rv__skel"></div><div class="rv__skel"></div>';
    load();
  }

  /**
   * 投稿フォーム本体。投稿ページ(/pages/review)と PDP のモーダルの両方から使う。
   * opts.single = true のときは対象商品を preselect に固定し、商品の選択リストを出さない。
   */
  function mountForm(body, opts) {
    var base = opts.base || '/apps/reviews';
    var mypageUrl = opts.mypageUrl || '/pages/mypage';
    var maxPhotos = opts.maxPhotos || 3;
    var preselect = opts.preselect || '';
    var single = !!opts.single;
    var existing = opts.existing || null;
    var state = { items: [], selected: null, rating: 0, fit: 0, comfort: 0, photos: [], profile: {}, mediaEnabled: false, title: '', body: '' };

    function render() {
      if (single && !state.selected) {
        var reviewed = (state.mine || []).some(function (r) { return String(r.product_id) === String(preselect); });
        body.innerHTML = '<div class="rvf__done"><h3>' + (reviewed ? 'この商品はレビュー投稿済みです' : 'この商品はまだレビューできません') + '</h3>'
          + '<p class="rv__cta-note">' + (reviewed ? 'ありがとうございます。掲載まで少しお時間をいただく場合があります。' : 'ご購入いただいた商品(直近1年)がレビューの対象です。ご購入直後は反映まで少し時間がかかることがあります。') + '</p></div>';
        return;
      }
      if (!single && !state.items.length) {
        body.innerHTML = '<div class="rvf__done"><h3>レビューできる商品がありません</h3><p class="rv__cta-note">直近1年のご購入商品がレビューの対象です。すでに投稿済みの商品は表示されません。</p><p><a class="rv__btn rv__btn--ghost" href="' + esc(mypageUrl) + '">マイページへ</a></p></div>' + mineHtml();
        return;
      }
      var items = state.items.map(function (it) {
        return '<button type="button" class="rvf__item" data-rvf-pick="' + it.product_id + '" aria-pressed="' + (state.selected && state.selected.product_id === it.product_id ? 'true' : 'false') + '">'
          + (it.image ? '<img src="' + esc(it.image) + '" alt="">' : '<span></span>')
          + '<span><span class="rvf__item-t">' + esc(it.title) + '</span><br><span class="rvf__item-s">' + esc(it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title + ' ・ ' : '') + fmtDate(it.ordered_at) + ' 購入</span></span>'
          + '<span class="rv__badge">' + (state.selected && state.selected.product_id === it.product_id ? '選択中' : '選ぶ') + '</span></button>';
      }).join('');
      var st = '';
      for (var i = 1; i <= 5; i++) st += '<button type="button" data-rvf-star="' + i + '" class="' + (state.rating >= i ? 'is-on' : '') + '" aria-label="' + i + '">' + STAR + '</button>';
      var starLbl = ['', 'いまいち', 'ふつう', 'よい', 'とてもよい', '最高'][state.rating] || '';
      var photosHtml = state.photos.map(function (p, i) {
        return '<div class="rvf__photo"><img src="' + p.preview + '" alt=""><button type="button" data-rvf-rm="' + i + '" aria-label="削除">×</button></div>';
      }).join('') + (state.photos.length < maxPhotos ? '<button type="button" class="rvf__add" data-rvf-add>＋ 写真<br>(' + state.photos.length + '/' + maxPhotos + ')</button>' : '');
      var picker = single
        ? '<div class="rvf__target' + (state.selected.image ? '' : ' rvf__target--noimg') + '">' + (state.selected.image ? '<img src="' + esc(state.selected.image) + '" alt="">' : '') + '<span><span class="rvf__item-t">' + esc(state.selected.title) + '</span><br><span class="rvf__item-s">' + (existing ? fmtDate(existing.created_at) + ' に投稿' : state.selected.ordered_at ? esc(state.selected.variant_title && state.selected.variant_title !== 'Default Title' ? state.selected.variant_title + ' ・ ' : '') + fmtDate(state.selected.ordered_at) + ' 購入' : '購入履歴なし(購入者バッジは付きません)') + '</span></span></div>'
        : '<div class="rvf__field"><span class="rvf__lbl">レビューする商品</span><div class="rvf__items">' + items + '</div></div>';
      body.innerHTML = '<div class="rvf">'
        + picker
        + '<form data-rvf-form' + (state.selected ? '' : ' hidden') + '>'
        + '<div class="rvf__field"><label class="rvf__lbl" for="rvf-author">表示名<small class="rvf__req">必須</small><small>レビューに表示されます</small></label><input class="rvf__input" id="rvf-author" name="author_name" maxlength="30" required value="' + esc(state.profile.author_name || '') + '"></div>'
        + '<div class="rvf__field"><span class="rvf__lbl">評価<small class="rvf__req">必須</small></span><div class="rvf__stars">' + st + '</div><span class="rvf__stars-lbl">' + starLbl + '</span></div>'
        + '<div class="rvf__field"><label class="rvf__lbl" for="rvf-variant">着用サイズ<small class="rvf__req">必須</small></label><select class="rvf__input" id="rvf-variant" name="variant_id" required><option value="">選んでください</option>'
        +   (state.selected.variants || []).map(function (v) { return '<option value="' + esc(v.variant_id) + '"' + (String(v.variant_id) === String(state.selected.variant_id || '') ? ' selected' : '') + '>' + esc(v.title === 'Default Title' ? '標準' : v.title) + '</option>'; }).join('')
        + '</select></div>'
        + '<div class="rvf__field"><label class="rvf__lbl" for="rvf-title">タイトル<small>任意・60文字まで</small></label><input class="rvf__input" id="rvf-title" name="title" maxlength="60" placeholder="例: 通勤にも週末にも" value="' + esc(state.title) + '"></div>'
        + '<div class="rvf__field"><label class="rvf__lbl" for="rvf-body">レビュー本文<small class="rvf__req">必須</small><small>10〜2000文字</small></label><textarea class="rvf__textarea" id="rvf-body" name="body" maxlength="2000" required placeholder="着心地、サイズ感、色味、合わせ方など、これから買う方の参考になることを教えてください">' + esc(state.body) + '</textarea><div class="rvf__count"><span data-rvf-count>' + state.body.length + '</span> / 2000</div></div>'
        + '<div class="rvf__field"><span class="rvf__lbl">' + SCALES.fit.label + '<small>任意</small></span>' + scaleControl('fit', state.fit) + '</div>'
        + '<div class="rvf__field"><span class="rvf__lbl">' + SCALES.comfort.label + '<small>任意</small></span>' + scaleControl('comfort', state.comfort) + '</div>'
        + '<div class="rvf__field"><label class="rvf__check"><input type="checkbox" name="show_profile" data-rvf-profile' + (state.profile.on ? ' checked' : '') + '> 身長・体重を載せる</label><p class="rvf__hint">「172cm / 64kg で M を着用」のように、選んだ着用サイズと並べて表示されます。同じ体型の方のサイズ選びの参考になります</p>'
        +   '<div class="rvf__row" data-rvf-profile-fields' + (state.profile.on ? '' : ' hidden') + ' style="margin-top:8px">'
        +     '<input class="rvf__input" type="number" name="height_cm" inputmode="numeric" min="100" max="250" placeholder="身長 cm" value="' + esc(state.profile.height_cm || '') + '">'
        +     '<input class="rvf__input" type="number" name="weight_kg" inputmode="numeric" min="25" max="200" placeholder="体重 kg" value="' + esc(state.profile.weight_kg || '') + '">'
        +   '</div></div>'
        + (state.mediaEnabled ? '<div class="rvf__field"><span class="rvf__lbl">写真<small>任意・' + maxPhotos + '枚まで</small></span><div class="rvf__photos" data-rvf-photos>' + photosHtml + '</div><input type="file" accept="image/*" multiple hidden data-rvf-file></div>' : '')
        + '<div data-rvf-err class="rv__err" hidden></div>'
        + (existing
          ? '<div class="rv__cta"><button type="submit" class="rv__btn" data-rvf-submit>変更を送信する</button><span class="rv__cta-note">変更すると「確認中」に戻り、確認が済むまで商品ページには表示されません</span></div>'
          : '<div class="rv__cta"><button type="submit" class="rv__btn" data-rvf-submit>レビューを送信する</button><span class="rv__cta-note">内容を確認のうえ掲載します(掲載まで数日いただく場合があります)</span></div>')
        + '</form></div>' + (single ? '' : mineHtml());
    }

    function mineHtml() {
      var out = '';
      if (state.mine && state.mine.length) {
        var lbl = { pending: '確認中', approved: '掲載中', rejected: '非掲載' };
        out += '<div class="rvf__mine"><h3>投稿したレビュー</h3><div class="rv__list rv--lines">' + state.mine.map(function (r) {
          return '<div class="rv__item"><div class="rv__item-head">' + stars(r.rating) + '<span class="rv__badge">' + (lbl[r.status] || r.status) + '</span><span class="rv__meta">' + fmtDate(r.created_at) + '</span></div>'
            + (r.title ? '<div class="rv__item-title">' + esc(r.title) + '</div>' : '') + '<p class="rv__item-body">' + esc(r.body) + '</p></div>';
        }).join('') + '</div></div>';
      }
      if (state.mineQuestions && state.mineQuestions.length) {
        var ql = { pending: '回答待ち', answered: '回答済み', hidden: '非掲載' };
        out += '<div class="rvf__mine"><h3>投稿した質問</h3><div class="rv__list rv--lines">' + state.mineQuestions.map(function (q) {
          return '<div class="rv__item"><div class="rv__item-head"><span class="rv__badge">' + (ql[q.status] || q.status) + '</span><span class="rv__meta">' + fmtDate(q.created_at) + '</span></div><p class="rv__item-body">' + esc(q.question) + '</p>'
            + (q.answer ? '<div class="rv__reply"><span class="rv__reply-lbl">回答 ' + fmtDate(q.answered_at) + '</span>' + esc(q.answer) + '</div>' : '') + '</div>';
        }).join('') + '</div></div>';
      }
      return out;
    }

    function pick(pid) {
      state.selected = state.items.find(function (it) { return it.product_id === pid; }) || null;
      render();
      var f = body.querySelector('[data-rvf-form]');
      if (f) f.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    body.addEventListener('click', function (ev) {
      var p = ev.target.closest('[data-rvf-pick]');
      if (p) { pick(p.getAttribute('data-rvf-pick')); return; }
      var s = ev.target.closest('[data-rvf-star]');
      if (s) { state.rating = Number(s.getAttribute('data-rvf-star')); syncStars(); return; }
      var sc = ev.target.closest('[data-rvf-scale]');
      if (sc) {
        var kind = sc.getAttribute('data-rvf-scale'); var v = Number(sc.getAttribute('data-v'));
        state[kind] = state[kind] === v ? 0 : v;
        body.querySelectorAll('[data-rvf-scale="' + kind + '"]').forEach(function (x) { x.setAttribute('aria-pressed', Number(x.getAttribute('data-v')) === state[kind] ? 'true' : 'false'); });
        var pk = body.querySelector('[data-rvf-scale-picked="' + kind + '"]');
        if (pk) { var scd = SCALES[kind]; var val = state[kind]; pk.textContent = val ? (val <= 2 ? (val === 1 ? scd.min : 'やや' + scd.min) : val >= 4 ? (val === 5 ? scd.max : 'やや' + scd.max) : scd.center) : ''; }
        return;
      }
      if (ev.target.closest('[data-rvf-add]')) { body.querySelector('[data-rvf-file]').click(); return; }
      var rm = ev.target.closest('[data-rvf-rm]');
      if (rm) { state.photos.splice(Number(rm.getAttribute('data-rvf-rm')), 1); renderPhotos(); }
    });
    body.addEventListener('input', function (ev) {
      if (ev.target.matches('#rvf-body')) body.querySelector('[data-rvf-count]').textContent = ev.target.value.length;
    });
    body.addEventListener('change', function (ev) {
      if (ev.target.matches('[data-rvf-profile]')) {
        state.profile.on = ev.target.checked;
        body.querySelector('[data-rvf-profile-fields]').hidden = !ev.target.checked;
      }
      if (ev.target.matches('[data-rvf-file]')) {
        var files = Array.prototype.slice.call(ev.target.files || []);
        ev.target.value = '';
        var room = maxPhotos - state.photos.length;
        Promise.all(files.slice(0, room).map(function (f) { return resizeImage(f, 1600, 0.85); })).then(function (list) {
          list.forEach(function (f) { state.photos.push({ file: f, preview: URL.createObjectURL(f) }); });
          renderPhotos();
        });
      }
    });
    body.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var form = ev.target;
      var errEl = form.querySelector('[data-rvf-err]');
      var btn = form.querySelector('[data-rvf-submit]');
      errEl.hidden = true;
      if (!state.selected) { showErr('商品を選んでください'); return; }
      if (!form.author_name.value.trim()) { showErr('表示名を入力してください'); form.author_name.focus(); return; }
      if (!state.rating) { showErr('評価(星)を選んでください'); return; }
      if (!form.variant_id.value) { showErr('着用サイズを選んでください'); form.variant_id.focus(); return; }
      var fd = new FormData();
      fd.append('product_id', state.selected.product_id);
      fd.append('variant_id', form.variant_id.value);
      if (state.selected.order_id) fd.append('order_id', state.selected.order_id);
      fd.append('rating', String(state.rating));
      fd.append('title', form.title.value);
      fd.append('body', form.body.value);
      fd.append('fit_score', state.fit ? String(state.fit) : '');
      fd.append('comfort', state.comfort ? String(state.comfort) : '');
      fd.append('show_profile', form.show_profile.checked ? '1' : '0');
      fd.append('height_cm', form.height_cm.value);
      fd.append('weight_kg', form.weight_kg.value);
      fd.append('author_name', form.author_name.value);
      fd.append('source', preselect ? 'mypage' : 'site');
      state.photos.forEach(function (p) { fd.append('photos', p.file, 'photo.jpg'); });
      btn.disabled = true; btn.textContent = '送信中…';
      var request = existing
        ? api(base, '/review/' + existing.id + '/update', { method: 'POST', body: JSON.stringify({
            product_id: existing.product_id, variant_id: form.variant_id.value, rating: state.rating, title: form.title.value, body: form.body.value,
            fit_score: state.fit || '', comfort: state.comfort || '', show_profile: form.show_profile.checked ? '1' : '0',
            height_cm: form.height_cm.value, weight_kg: form.weight_kg.value, author_name: form.author_name.value
          }) })
        : api(base, '/submit', { method: 'POST', body: fd });
      request.then(function () {
        body.innerHTML = '<div class="rvf__done"><h3>' + (existing ? '変更を受け付けました' : 'レビューをお預かりしました') + '</h3><p>' + (existing ? '内容を確認のうえ、あらためて商品ページに掲載します。' : '内容を確認のうえ、商品ページに掲載します。ありがとうございます。') + '</p>'
          + (single
            ? '<p class="rv__cta" style="justify-content:center"><button type="button" class="rv__btn" data-rv-modal-close>閉じる</button></p>'
            : '<p class="rv__cta" style="justify-content:center"><a class="rv__btn rv__btn--ghost" href="' + esc(location.pathname) + '">別の商品をレビューする</a><a class="rv__btn" href="' + esc(mypageUrl) + '">マイページへ</a></p>') + '</div>';
        if (opts.onDone) opts.onDone(); else window.scrollTo({ top: 0, behavior: 'smooth' });
      }).catch(function (e) {
        showErr(e.message); btn.disabled = false; btn.textContent = existing ? '変更を送信する' : 'レビューを送信する';
      });
      function showErr(msg) { errEl.textContent = msg; errEl.hidden = false; errEl.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    });

    function syncStars() {
      body.querySelectorAll('[data-rvf-star]').forEach(function (x) { x.classList.toggle('is-on', Number(x.getAttribute('data-rvf-star')) <= state.rating); });
      var lbl = body.querySelector('.rvf__stars-lbl'); if (lbl) lbl.textContent = ['', 'いまいち', 'ふつう', 'よい', 'とてもよい', '最高'][state.rating] || '';
    }
    function renderPhotos() {
      var wrap = body.querySelector('[data-rvf-photos]'); if (!wrap) return;
      wrap.innerHTML = state.photos.map(function (p, i) {
        return '<div class="rvf__photo"><img src="' + p.preview + '" alt=""><button type="button" data-rvf-rm="' + i + '" aria-label="削除">×</button></div>';
      }).join('') + (state.photos.length < maxPhotos ? '<button type="button" class="rvf__add" data-rvf-add>＋ 写真<br>(' + state.photos.length + '/' + maxPhotos + ')</button>' : '');
    }

    if (existing) {
      state.selected = {
        product_id: existing.product_id,
        title: existing.product ? existing.product.title : '',
        image: existing.product ? existing.product.image : null,
        variants: existing.variants || [],
        variant_id: existing.variant_id
      };
      state.rating = existing.rating;
      state.fit = existing.fit_score || 0;
      state.comfort = existing.comfort || 0;
      state.title = existing.title || '';
      state.body = existing.body || '';
      state.profile = { author_name: existing.author, height_cm: existing.height_cm, weight_kg: existing.weight_kg, on: existing.show_profile };
      render();
      return;
    }
    body.innerHTML = '<div class="rv__skel"></div>';
    Promise.all([api(base, '/eligible' + (single && preselect ? '?product_id=' + encodeURIComponent(preselect) : '')), api(base, '/mine').catch(function () { return { items: [], questions: [] }; })]).then(function (res) {
      var e = res[0];
      state.items = e.items || [];
      state.profile = { author_name: e.profile.author_name, height_cm: e.profile.height_cm, weight_kg: e.profile.weight_kg, on: true };
      state.mediaEnabled = !!e.media_enabled;
      state.mine = res[1].items || [];
      state.mineQuestions = res[1].questions || [];
      if (preselect && state.items.some(function (it) { return String(it.product_id) === String(preselect); })) state.selected = state.items.find(function (it) { return String(it.product_id) === String(preselect); });
      else if (!single && state.items.length === 1) state.selected = state.items[0];
      render();
    }).catch(function (e) {
      body.innerHTML = '<div class="rv__err">' + esc(e.message) + '</div>';
    });
  }

  function init() {
    document.querySelectorAll('[data-rv-role]').forEach(function (root) {
      if (root.dataset.rvInit) return;
      root.dataset.rvInit = '1';
      var role = root.getAttribute('data-rv-role');
      if (role === 'pdp') initPdp(root);
      else if (role === 'recent') initRecent(root);
      else if (role === 'form') initForm(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
